import React from 'react';

// ── Общие стили модалок создания/редактирования компании (строго по макету) ──
export const labelCls = 'text-[16px] leading-[24px] font-medium text-[#0A0D14] tracking-[-0.011em]';
export const inputBase =
  'h-10 w-full rounded-[10px] border border-[#E2E4E9] bg-white outline-none ' +
  'shadow-[0px_1px_2px_rgba(228,229,231,0.24)] focus:border-[#E16349] ' +
  'text-[#0A0D14] tracking-[-0.006em] placeholder:text-[#868C98]';
export const tariffLabelCls =
  'text-[14px] leading-[22px] font-medium tracking-[-0.234px] text-[#989286]';

export const TARIFF_MODULES = [
  { key: 'searchCreditsPriceKopecks' as const, label: 'Скоринг (₽/шт)' },
  { key: 'dialogCreditsPriceKopecks' as const, label: 'Диалог (₽/шт)' },
  { key: 'interviewCreditsPriceKopecks' as const, label: 'AI-скрининг (₽/шт)' },
];

// ── Иконки (инлайн-SVG, пути RemixIcon) ───────────────────────────────────────
export const CloseIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636 12 10.586z" />
  </svg>
);
// ri-gift-2-fill — клик открывает дату старта пилота («подарок»)
export const GiftIcon: React.FC<{ color: string }> = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill={color}>
    <path d="M15 2a4 4 0 0 1 3.464 6.001L23 8v2h-2v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9H1V8l4.536.001A4 4 0 0 1 12 3.355 3.983 3.983 0 0 1 15 2zm-4 8H5v8h6v-8zm8 0h-6v8h6v-8zM9 4a2 2 0 0 0-.15 3.995L9 8h2V6a2 2 0 0 0-1.85-1.995L9 4zm6 0a2 2 0 0 0-1.995 1.85L13 6v2h2a2 2 0 0 0 .15-3.995L15 4z" />
  </svg>
);
// ri-question-line
export const QuestionIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#525866" className="shrink-0">
    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm2-1.645V14h-2v-1.5a1 1 0 0 1 1-1 1.5 1.5 0 1 0-1.471-1.794l-1.962-.393A3.501 3.501 0 1 1 13 13.355z" />
  </svg>
);
export const ChevronUp: React.FC = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="#868C98">
    <path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z" />
  </svg>
);
export const ChevronDown: React.FC = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="#868C98">
    <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
  </svg>
);

/**
 * Тёмный тултип-подсказка по макету: появляется над триггером по ховеру,
 * фон #20232D, белый текст 14/20, скругление 6px, хвостик-треугольник вниз справа.
 */
export const InfoTooltip: React.FC<{ text: string; children: React.ReactNode }> = ({ text, children }) => (
  <span className="relative inline-flex group">
    {children}
    <span className="pointer-events-none absolute bottom-full right-0 mb-2 z-30 hidden group-hover:flex flex-col items-end">
      <span className="w-[205px] whitespace-normal rounded-[6px] bg-[#20232D] px-2.5 py-1 text-left text-[14px] leading-[20px] tracking-[-0.006em] text-white shadow-[0px_12px_24px_rgba(134,140,152,0.12),0px_1px_2px_rgba(228,229,231,0.24)]">
        {text}
      </span>
      <span
        className="mr-3 -mt-px h-1.5 w-3 bg-[#20232D]"
        style={{ clipPath: 'polygon(0 0, 100% 0, 50% 100%)' }}
      />
    </span>
  </span>
);

// ── Хелперы ───────────────────────────────────────────────────────────────────
/** Авто-маска ввода даты: «18092026» → «18.09.2026», точки проставляются на лету. */
export const maskDate = (input: string): string => {
  const d = input.replace(/\D/g, '').slice(0, 8);
  let out = d.slice(0, 2);
  if (d.length >= 3) out += '.' + d.slice(2, 4);
  if (d.length >= 5) out += '.' + d.slice(4, 8);
  return out;
};

/** «дд.мм.гггг» → ISO «гггг-мм-дд» (с проверкой диапазонов); undefined если невалидно/неполно. */
export const toIso = (s: string): string | undefined => {
  const m = s.trim().match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (!m) return undefined;
  const day = +m[1];
  const mon = +m[2];
  const year = +m[3];
  if (mon < 1 || mon > 12 || day < 1 || day > 31 || year < 1900) return undefined;
  return `${m[3]}-${m[2]}-${m[1]}`;
};

/** ISO «гггг-мм-дд» → «дд.мм.гггг» для отображения (для формы редактирования). */
export const isoToDisplay = (iso?: string | null): string => {
  if (!iso) return '';
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : '';
};

/** Дата заполнена полностью (10 символов), но невалидна — для красной рамки. */
export const isDateInvalid = (s: string) => s.length === 10 && !toIso(s);

/** Денежная маска: цифры + одна десятичная точка (до 2 знаков). «1000,50» → «1000.50». */
export const moneyMask = (input: string): string => {
  const s = input.replace(/[^\d.,]/g, '').replace(',', '.');
  const [int, ...rest] = s.split('.');
  if (rest.length === 0) return int;
  return `${int}.${rest.join('').slice(0, 2)}`;
};
